/** @jsx jsx */
import { jsx, css } from "@emotion/core";
// import React from "react";
import Icon from "../GlobalComponents/Icon";
import GymTitle from "./GymTitle";
import GymSubtitle from "./GymSubtitle";
import GymProgramCard from "./GymProgramCard";
import Container from "../GlobalComponents/Container";

const GymProgram = () => (
  <div css={styles} className="gymProgram">
    <GymTitle />
    <Icon />
    <GymSubtitle />
    <Container>
      <GymProgramCard
        title="Fitness / Strength Training"
        desc="Strength training can help you increase bone strength and muscular fitness, and it can help you manage or lose weight."
      />
      <GymProgramCard
        title="Body Building"
        desc="Bodybuilding is the use of progressive resistance exercise to control and develop one's muscles by muscle."
      />
      <GymProgramCard
        title="Zumba / Aerobics"
        desc="Zumba is a fitness program that involves cardio and Latin-inspired dance. "
      />
      <GymProgramCard
        title="Personal Training"
        desc="A personal trainer is an individual who creating and delivering safe and effective exercise programs for individuals and groups."
      />
      <GymProgramCard
        title="Nutrition Planning"
        desc="A diet plan is tailored to an individual's health status, weight and lifestyle, along with their weight loss and health goals."
      />
      <GymProgramCard
        title="Group Classes"
        desc="Find motivation and inspiration. Proper form helps prevent injury. Be part of a community"
      />
    </Container>
  </div>
);

const styles = css`
  width: 100%;
  min-height: 100vh;
  text-align: center;
  padding: 120px 0;
  .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 40px 0;
  }
  @media (max-width: 700px) {
    .container {
      flex-direction: column;
      justify-content: flex-start;
    }
  }
  @media (min-width: 701px) and (max-width: 1100px) {
    .container {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export default GymProgram;
